export default "__VITE_ASSET__Bs8l$nUc__"